module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    staticClass: "ds-calendar-event-menu",
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('div', {
    staticClass: "ds-calendar-event",
    style: (_vm.style),
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editCheck($event)
      },
      "mouseenter": _vm.mouseEnterEvent,
      "mouseleave": _vm.mouseLeaveEvent,
      "mousedown": _vm.mouseDownEvent,
      "mouseup": _vm.mouseUpEvent
    },
    slot: "activator"
  }, [(_vm.showName) ? _c('span', [_vm._t("eventTitle", [(_vm.hasIcon) ? _c('v-icon', {
    staticClass: "ds-ev-icon",
    style: ({
      color: _vm.details.forecolor
    }),
    attrs: {
      "size": "14"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.details.icon) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.hasPrefix) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.getPrefix) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('strong', {
    staticClass: "ds-ev-title"
  }, [_vm._v(_vm._s(_vm.details.title))]), _vm._v(" "), _c('span', {
    staticClass: "ds-ev-description"
  }, [_vm._v(_vm._s(_vm.details.description))])], null, {
    calendarEvent: _vm.calendarEvent,
    hasPrefix: _vm.hasPrefix,
    getPrefix: _vm.getPrefix,
    details: _vm.details
  })], 2) : _c('span', [_vm._t("eventEmpty", [_vm._v(" ")], null, {
    calendarEvent: _vm.calendarEvent,
    details: _vm.details
  })], 2)]), _vm._v(" "), _vm._t("eventPopover", null, null, {
    calendarEvent: _vm.calendarEvent,
    calendar: _vm.calendar,
    edit: _vm.edit,
    details: _vm.details,
    close: _vm.close
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46108b38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarEvent.vue
// module id = 165
// module chunks = 0